// @flow
import * as React from 'react';
import { Flex, Text } from '@locus-taxy/neo-ui';

import {
    rankWith,
    uiTypeIs,
    or,
    isStringView,
    useViewProps,
    type Tester
} from 'platform/settings/form/JsonView';

type Props = {};

const TextFieldView = (props: Props): React.Node => {
    const { data, label } = useViewProps(props);

    return (
        <Flex>
            <Text size="regular" color="grey.600">
                {label}:
            </Text>
            <Text size="regular" color="grey.900" fontWeight="bold" ml={1}>
                {data}
            </Text>
        </Flex>
    );
};

export default TextFieldView;

export const textFieldViewTester: Tester = rankWith(
    1,
    or(uiTypeIs('TextFieldView'), isStringView)
);
